export default __webpack_public_path__ + "static/media/annalise.14b13be9.webm";